export default __webpack_public_path__ + "static/CloisonsPARTENA-510e5860645cae09630213693523a389.png";